const musicLinksValidationPT = {
    "add": {
        "release_name": {
            "required": "Nome do Lançamento é obrigatório"
        },
        "ean": {
            "required": "EAN/UPC é obrigatório"
        },
        "artist_name": {
            "required": "Nome do Artista é obrigatório"
        },
        "url_part1": {
            "required": "Parte 1 da URL é obrigatória"
        },
        "url_part2": {
            "required": "Parte 2 da URL é obrigatória",
            "length": "Parte 2 da URL não pode ter mais de 10 caracteres",
            "duplicate": "Ops! Esta URL já está associada a outro link de música. Por favor, tente outra URL.",
            "urlAvailable": "URL está disponível",
            "urlInvalid": "URL é inválida"
        },
        "amazonmusic_url": {
            "required": "URL do Amazon Music é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Amazon Music."
        },
        "applemusic_url": {
            "required": "URL do Apple Music é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Apple Music."
        },
        "beatport_url": {
            "required": "URL do Beatport é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Beatport."
        },
        "deezer_url": {
            "required": "URL do Deezer é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Deezer."
        },
        "junodownload_url": {
            "required": "URL do Junodownload é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Junodownload."
        },
        "soundcloud_url": {
            "required": "URL do Soundcloud é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Soundcloud."
        },
        "spotify_url": {
            "required": "URL do Spotify é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Spotify."
        },
        "tidal_url": {
            "required": "URL do Tidal é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Tidal."
        },
        "traxsource_url": {
            "required": "URL do Traxsource é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Traxsource."
        },
        "youtube_url": {
            "required": "URL do Youtube é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Youtube."
        },
        "anghami_url": {
            "required": "URL do Anghami é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "bandcamp_url": {
            "required": "URL do Bandcamp é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "boomplay_url": {
            "required": "URL do Boomplay é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "iheartradio_url": {
            "required": "URL do iHeartRadio é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "jiosaavn_url": {
            "required": "URL do JioSaavn é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "sevendigital_url": {
            "required": "URL do 7digital é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "other_url": {
            "invalid": "Por favor, adicione uma URL válida."
        },
        "pvTrackName": {
            "required": "Nome da Faixa é obrigatório"
        },
        "pvArtistName": {
            "required": "Nome do Artista é obrigatório"
        }
    },
    "update": {
        "release_name": {
            "required": "Nome do Lançamento é obrigatório"
        },
        "ean": {
            "required": "EAN/UPC é obrigatório"
        },
        "artist_name": {
            "required": "Nome do Artista é obrigatório"
        },
        "url_part1": {
            "required": "Parte 1 da URL é obrigatória"
        },
        "url_part2": {
            "required": "Parte 2 da URL é obrigatória",
            "length": "Parte 2 da URL não pode ter mais de 10 caracteres",
            "duplicate": "Ops! Esta URL já está associada a outro link de música. Por favor, tente outra URL.",
            "urlAvailable": "URL está disponível",
            "urlInvalid": "URL é inválida"
        },
        "amazonmusic_url": {
            "required": "URL do Amazon Music é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Amazon Music."
        },
        "applemusic_url": {
            "required": "URL do Apple Music é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Apple Music."
        },
        "beatport_url": {
            "required": "URL do Beatport é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Beatport."
        },
        "deezer_url": {
            "required": "URL do Deezer é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Deezer."
        },
        "junodownload_url": {
            "required": "URL do Junodownload é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Junodownload."
        },
        "soundcloud_url": {
            "required": "URL do Soundcloud é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Soundcloud."
        },
        "spotify_url": {
            "required": "URL do Spotify é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Spotify."
        },
        "tidal_url": {
            "required": "URL do Tidal é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Tidal."
        },
        "traxsource_url": {
            "required": "URL do Traxsource é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Traxsource."
        },
        "youtube_url": {
            "required": "URL do Youtube é obrigatória",
            "invalid": "Por favor, adicione uma URL válida do Youtube."
        },
        "anghami_url": {
            "required": "URL do Anghami é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "bandcamp_url": {
            "required": "URL do Bandcamp é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "boomplay_url": {
            "required": "URL do Boomplay é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "iheartradio_url": {
            "required": "URL do iHeartRadio é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "jiosaavn_url": {
            "required": "URL do JioSaavn é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "sevendigital_url": {
            "required": "URL do 7digital é obrigatória",
            "invalid": "Por favor, adicione uma URL válida."
        },
        "other_url": {
            "invalid": "Por favor, adicione uma URL válida."
        },
        "pvTrackName": {
            "required": "Nome da Faixa é obrigatório"
        },
        "pvArtistName": {
            "required": "Nome do Artista é obrigatório"
        }
    }
};

export default musicLinksValidationPT;